// extracted by mini-css-extract-plugin
export default {"wrapper":"q3BMRnwBl6EGP7AZViTL","form":"UR1LXaDlztra9ZGNgsiv","input":"E5cbiq7dRY2rJ_IpjDjJ"};